import { render, staticRenderFns } from "./managerSubmit.vue?vue&type=template&id=2c168fa4&scoped=true"
import script from "./managerSubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./managerSubmit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c168fa4",
  null
  
)

export default component.exports